import type { AllRouteEndpoints } from "../routeTypes";
export const appSettingsAuthenticationCredentialCreateCacheKeys: AllRouteEndpoints[] = [
  "/app_settings/authentication_credentials",
];
